import React from "react";
import MiradorMenuButton from "mirador/dist/es/src/containers/MiradorMenuButton";
import Card from "@material-ui/core/Card";

import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import ImageDl from "./ImageDl";
import PdfDl from "./PdfDl";
import ManifestDl from "./ManifestDl";
import ImageZipDl from "./ImageZipDl";

import "./PopUp.css";

export default function PopUp(props) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const t = props.t;

  return (
    <div>
      <MiradorMenuButton aria-label="Download" onClick={handleOpen}>
        <GetAppOutlinedIcon />
      </MiradorMenuButton>
      <Dialog maxWidth="sm" onClose={handleClose} open={open}>
        <DialogTitle className="dialogTitle" id="bla" onClose={handleClose}>
          <Typography variant="h2">
            {t("downloadMenu")}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Card>
            <Typography fontWeight="fontWeightBold">{t("images")}:</Typography>

            <ImageDl
              canvases={props.canvases}
              canvasLabel={props.canvasLabel}
              infoResponse={props.infoResponse}
              t={t}
            />
            <ImageZipDl
              t={t}
              manifest={props.manifest}
              canvases={props.canvases}
            />
          </Card>
          <br />
          <Card>
            <Typography fontWeight="fontWeightBold">
              {t("otherOptions")}:
            </Typography>
            <PdfDl
              manifestUrl={props.manifestUrl}
              t={t}
              manifest={props.manifest}
            />
            <ManifestDl manifestUrl={props.manifestUrl} />
          </Card>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}